import React, { useState } from "react";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import {
  // Button,
  Card,
  Tooltip,
  Pagination,
  Table,
  Progress,
  Row,
  Col,
  Space,
  Tag,
} from "antd";

import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { GetSpacedSpan, GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import {
  AppstoreOutlined,
  BarsOutlined,
  PieChartOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  // UpOutlined,
  // DownOutlined,
} from "@ant-design/icons";
import UserProgressCard from "./UserProgressCard";

// const { Title } = Typography;
const UserViewExpandable = ({ record, id }) => {
  const [loadAgain, setLoadAgain] = useState(false);
  const [modernView, setModernView] = useState(false);
  const [summary, setSummary] = useState(false);
  const toggleView = () => setModernView((prev) => !prev);
  const toggleSummary = () => setSummary((prev) => !prev);
  // eslint-disable-next-line no-unused-vars
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/bundleusercourselist/${id}/${record?.id}/`,
    loadAgain: loadAgain,
    skip: !record?.id,
  });

  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  const columns = [
    {
      title: "Course ID",
      dataIndex: "course_code",
      key: "course_code",
      width: 140,
      render: (text) => GetSpacedSpan(text),
    },
    {
      title: "Name",
      dataIndex: "course_name",
      key: "course_name",
      width: 250,
      ellipsis: true,
      render: (text) => GetSpacedSpan(text),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (text) => GetSpacedSpan(text),
    },
    {
      title: "Mode",
      dataIndex: "mode",
      key: "Mode",
      width: 150,
      render: (text) => GetSpacedSpan(text),
    },
    {
      title: "Reset Enabled",
      dataIndex: "is_reset_enabled",
      key: "reset_enabled",
      width: 150,
      render: (text) => (
        <div className="givePadding">
          {text ? (
            <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "1.2rem" }} />
          ) : (
            <CloseCircleTwoTone twoToneColor="#f5222d" style={{ fontSize: "1.2rem" }} />
          )}
        </div>
      ),
    },
    {
      title: "Next Reset Date",
      dataIndex: "next_run_date",
      key: "next_run_date",
      width: 150,
      render: (text) => GetSpacedSpan(GetFormattedDateTime(text)),
    },
  ];
  const STATUS_COLORS = {
    "Not Enrolled": "default",
    Enrolled: "processing",
    Started: "warning",
    Completed: "success",
  };

  const STATUS_PROGRESS = {
    "Not Enrolled": 0,
    Enrolled: 25,
    Started: 50,
    Completed: 100,
  };
  return (
    <Card style={{ width: "100%" }}>
      {summary && <UserProgressCard record={record} />}
      <CommonTopDetails
        title={`${record?.full_name}'s Courses`}
        titleSuffix={`${itemsLength || 0} content(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={false}
        marginPass="0px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        variantPass={"sm"}
        customContent={
          <>
            <Tooltip
              title={!summary ? "Show Summary" : "Hide Summary"}
              placement="bottom"
            >
              <div
                style={{
                  cursor: "pointer",
                  padding: "4px 6.5px",
                  display: "flex",
                  alignItems: "center",
                  background:
                    "linear-gradient(90deg, #f8fafc 0%, #e0eafc 100%)",
                  borderRadius: "8px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s",
                  marginBottom: "2.5px",
                }}
                onClick={toggleSummary}
              >
                <PieChartOutlined
                  style={{ fontSize: "20px", color: "#383737ff" }}
                />
              </div>
            </Tooltip>
            <Tooltip title={modernView ? "Switch to table" : "Switch to cards"}>
              <div
                style={{
                  cursor: "pointer",
                  padding: "3px 5.5px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#E6F7FF",
                  borderRadius: "8px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s",
                  marginBottom: "2.5px",
                }}
                onClick={toggleView}
              >
                {modernView ? (
                  <AppstoreOutlined
                    style={{ fontSize: "22.5px", color: "#595959" }}
                  />
                ) : (
                  <BarsOutlined style={{ fontSize: "22.5px" }} />
                )}
              </div>
            </Tooltip>
          </>
        }
      />
      {modernView ? (
        <Row gutter={[16, 16]}>
          {data.map((course) => (
            <Col xs={24} sm={12} md={8} lg={6} key={course.course_id}>
              <Card
                hoverable
                style={{ borderRadius: 8 }}
                bodyStyle={{ padding: "12px" }}
              >
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                  <div style={{ fontWeight: 500 }}>{course.course_name}</div>

                  <Progress
                    percent={STATUS_PROGRESS[course.status] || 0}
                    size="small"
                    strokeColor={
                      course.status === "Completed"
                        ? "#52c41a"
                        : course.status === "Started"
                        ? "#faad14"
                        : course.status === "Enrolled"
                        ? "#1677ff"
                        : "#d9d9d9"
                    }
                    showInfo={false}
                  />

                  <Tag color={STATUS_COLORS[course.status] || "default"}>
                    {course.status}
                  </Tag>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <>
          <Table
            columns={columns}
            dataSource={data}
            rowKey="content_id"
            size="small"
            loading={loading}
            className="table-container"
            style={{ margin: "1rem" }}
            pagination={false}
            scroll={{
              x: 500,
            }}
            bordered
          />
        </>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </Card>
  );
};

export default UserViewExpandable;
